import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Fb, HttpErrorInterface, ISearchCustomers, PermissionType, RolePermissionService, ApplicationContextService } from "lib-core-shared";

export enum Mode {
    new, edit, delete, read
}

@Directive({
    selector: 'app-component-base'
})
export class ComponentBaseDirective {
    @Input() public fb: Fb | undefined = { text: 'LDGILL', status: 'text-info' };
    @Input() public isBusy: boolean = false;
    @Input() public silentLoading: boolean = false;
    public queryParam: {} | undefined;
    @Input() public permission!:string;
    @Input() public permissionCreate!:string;
    @Input() public permissionUpdate!:string;
    @Input() public permissionDelete!:string;
    @Input() public permissionRead!:string;
    @Input() public mode!: Mode;
    @Output() public closeEmitter: EventEmitter<any>  = new EventEmitter<any> (false);
    constructor(
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public roleService: RolePermissionService,
        public applicationContext: ApplicationContextService
    ) { }

    public reportError(e: any, message: string) {
        this.isBusy = false;
        this.fb = {
            text: message,
            error: e
        };
        this.scrollToErrorMsg();
    }

    public isPermissionCreate(): boolean {

        if(this.isPublicAccessViaJwtAuth()) return true;

        const permissionOutcome = this.roleService.getPermission(this.permissionCreate);
        return permissionOutcome === PermissionType.create;
    }
    
    public isPermissionUpdate(): boolean {

        if(this.isPublicAccessViaJwtAuth()) return true;

        const permissionOutcome = this.roleService.getPermission(this.permissionUpdate);
        return permissionOutcome === PermissionType.update;
    }

    public isPermissionRead(): boolean {

        if(this.isPublicAccessViaJwtAuth()) return true;

        const permissionOutcome = this.roleService.getPermission(this.permissionRead);
        return permissionOutcome === PermissionType.read;
    }

    public isPermissionDelete(): boolean {

        if(this.isPublicAccessViaJwtAuth()) return true;

        const permissionOutcome = this.roleService.getPermission(this.permissionDelete);
        return permissionOutcome === PermissionType.delete;
    }

    public isPublicAccessViaJwtAuth(): boolean {
        return this.applicationContext.isJwtContext() ? true : false;
    }

    public get modeType() {
        return Mode;
    }

    public resetError() {
        this.fb = { text: 'LDGILL', status: 'text-info' };
    }

    public goToRoute(path: string) {
        if (this.queryParam)
            this.router.navigate([path], { relativeTo: this.activatedRoute, queryParams: this.queryParam });
        else
            this.router.navigate([path], { relativeTo: this.activatedRoute });
    }

    public getError():HttpErrorInterface {
        return this.fb?.error ? this.fb.error : {} as HttpErrorInterface;
    }

    public getText():string {
        return this.fb?.text ? this.fb.text : '';
    }

    public resetFeedBack() {
        this.fb = { text: 'LDGILL', status: 'text-info' };
    }
      
    public setItem(key: string, data: ISearchCustomers): void {
        if (this.getItem(key)) {
            localStorage.removeItem(key);
        }
        localStorage.setItem(key, JSON.stringify(data));
    }
    
    public getItem(key: string) {
        const item = localStorage.getItem(key); 
        if (item) {
            return JSON.parse(item);
        }
        return undefined;
    }
    
    public removeItem(key: string): void {
        localStorage.removeItem(key);
    }
    
    scrollToErrorMsg() {
        setTimeout(() => {
            let errorCard = document.getElementsByTagName('lib-error');
            errorCard[0].scrollIntoView({block: "end", inline: "center", behavior: "smooth"});
        }, 0)
    }
}